import React from "react";
import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import './transactionResponse.css';

const EscrowPaymentTransactionSuccess = () => {
    const { t } = useTranslation();
    return (
        <div className='bl-back-image'>
            <Row>
                <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{marginTop: '10%'}}>
                    <div>
                        <h1 className="text-center text-success text-congrats">
                            {t("escrowWallet.transactionSuccess.view.title")}
                        </h1>

                        <div className="text-center text-white pl-2 pr-2" style={{fontSize: '20px', marginTop: '40px'}}>
                            <p>
                                {t("escrowWallet.transactionSuccess.view.description")}
                            </p>
                        </div>

                        <div className="text-center mt-5">
                            <a href="/dashboard" className="btn btn-ml btn-lg mr-3">
                                <span className="fas fa-user pr-2"></span>
                                {t("escrowWallet.transactionSuccess.view.button.returnToDashboard")}
                            </a>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default EscrowPaymentTransactionSuccess;

